import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Button, Switch, Col, Row } from 'antd';
import { LOGGEDIN_USER_DATA } from 'global_config/constant-global';
import {
	createWardAndRoomsItems,
	updateWardAndRoomsItems,
} from 'services/settings/lookup_table/wardsAndRooms';
import { is } from 'immutable';

const WardAndRoomsForm = ({ buttonNames, selecetedData, onDrawerClose, onSuccessCreate, onSuccessUpdate, maxLocationSort }) => {

	const onFinish = async values => {
		const payload = {
			locationTypeID: values.locationTypeID,
			department: values.department ? values.department.toUpperCase() : '',
			name: values.name ? values.name.toUpperCase() : '',
			integrationCode: values.integrationCode ? values.integrationCode.toUpperCase() : '',
			is_active: values.is_active === true ? 1 : 0,
			// For UPDATE: keep existing sort, For CREATE: use maxLocationSort + 1
			locationSort: selecetedData ? selecetedData.locationSort : (maxLocationSort ? maxLocationSort + 1 : 1),
		};
		console.log("🚀 ~ onFinish ~ payload:", payload);
		console.log("🚀 ~ onFinish ~ maxLocationSort:", maxLocationSort);
		console.log("🚀 ~ onFinish ~ selecetedData:", selecetedData);


		if (buttonNames === 'ADD') {
			const created = await createWardAndRoomsItems(payload);
			if (created) {
				onSuccessCreate();
			}
		} else {
			payload.locationID = selecetedData.locationID;
			const updated = await updateWardAndRoomsItems(payload);
			if (updated) {
				onSuccessUpdate();
			}
		}
	};

	return (
		<div>
			<Form
				layout="vertical"
				onFinish={onFinish}
				initialValues={{
					locationTypeID: selecetedData ? selecetedData.locationTypeID : null,
					name: selecetedData ? selecetedData.name : null,
					department: selecetedData ? selecetedData.department : null,
					integrationCode: selecetedData ? selecetedData.integrationCode : null,
					is_active: selecetedData ? (selecetedData.active === 1 ? true : false) : true,
				}}
			>
				<Row>
					<Col span={4}>
						<Form.Item>
							<label>ACTIVE:</label>
						</Form.Item>
					</Col>

					<Col span={6}>
						<Form.Item name="is_active" valuePropName="checked">
							<Switch disabled={buttonNames === 'ADD'} />
						</Form.Item>
					</Col>
				</Row>
				<Form.Item
					label="WARD/ROOM NAME"
					name="name"
					rules={[{ required: true, message: 'This field is required' }]}
				>
					<Input maxLength={254} style={{ textTransform: 'uppercase' }} />
				</Form.Item>
				<Form.Item
					label="DEPARTMENT"
					name="department"
					rules={[{ required: true, message: 'This field is required' }]}
				>
					<Input maxLength={254} style={{ textTransform: 'uppercase' }} />
				</Form.Item>
				<Form.Item
					label="INTEGRATION CODE"
					name="integrationCode"
					// rules={[{ required: true, message: 'Please input Intergration Code!' }]}
				>
					<Input />
				</Form.Item>
				{/* <Form.Item
					label="INTEGRATION TYPE ID"
					name="locationTypeID"
					rules={[{ required: true, message: 'Please input Intergration Type id' }]}
				>
					<Input />
				</Form.Item> */}
				<section className="drawerFooter">
					<Button shape="round" onClick={onDrawerClose} style={{ marginRight: 8, width: 120 }}>CANCEL</Button>
					<Button type="primary" shape="round" style={{ margin: 10, width: 120 }} htmlType="submit">
						{buttonNames}
					</Button>
				</section>
			</Form>
		</div>
	);
};

export default WardAndRoomsForm;
